import { useState, useEffect, useCallback } from "react";

// allows us to easily change url parameters.
// we dont use react-router-dom, this is like a polyfill for it.
export function useSearchParams() {
  const getSearchParams = () => new URLSearchParams(window.location.search);
  const [params, setParams] = useState(() => Object.fromEntries(getSearchParams()));

  const setSearchParams = useCallback((newParams, { replace = false } = {}) => {
    newParams = Object.fromEntries(
      Object.entries(newParams).filter(
        ([_, value]) => value != null && value !== undefined && value !== ""
      )
    );

    const currentParams = getSearchParams();
    const nextParams = new URLSearchParams(
      typeof newParams === "function" ? newParams(currentParams) : newParams
    );

    const newUrl = `${window.location.pathname}?${nextParams.toString()}${window.location.hash}`;

    if (replace) {
      window.history.replaceState(null, "", newUrl);
    } else {
      window.history.pushState(null, "", newUrl);
    }

    window.dispatchEvent(new Event("urlchange"));
    setParams(Object.fromEntries(nextParams));
  }, []);

  useEffect(() => {
    const handleChange = () => setParams(Object.fromEntries(getSearchParams()));

    window.addEventListener("popstate", handleChange);
    window.addEventListener("urlchange", handleChange);

    return () => {
      window.removeEventListener("popstate", handleChange);
      window.removeEventListener("urlchange", handleChange);
    };
  }, []);

  return [params, setSearchParams];
}
